import { type BaseQueryMeta, createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiBlobRequest } from '#shared/api/requests';
import { OpenApiExportCharacteristicGroupsUrl } from '#shared/api/schema';
import { type DownloadableBlob, mapBlobResponse } from '#shared/lib/file';

const exportApi = createApi({
    name: 'entities/characteristic/api/export',
    tagTypes: [],
    baseQuery: createBaseQuery(apiBlobRequest),
    endpoints: (builder) => {
        return {
            exportGroups: builder.query<DownloadableBlob, undefined>({
                query: () => {
                    return {
                        url: OpenApiExportCharacteristicGroupsUrl,
                        method: 'GET',
                    };
                },
                transformResponse: (blobData: Blob, meta: BaseQueryMeta) =>
                    mapBlobResponse(blobData, meta, 'characteristic_groups.xlsx'),
            }),
        };
    },
});

export const useLazyExportCharacteristicsGroups = exportApi.useLazyExportGroupsQuery;
